import { TGetOrderResponse, TPageSettingsResponse } from '@p2p/services';
import {
  CHECKED_USER_LOCAL_STORAGE_KEY,
  failStatuses,
  IN_DISPUTE,
  MSP_CONFIRM_AMOUNT_SESSION_KEY,
  MSP_PAGE,
  NOT_FOUND_PAYMENT,
  ORDER_STATUS,
  successStatuses,
  UPLOADED_ORDER_LOCAL_STORAGE_KEY,
} from '@p2p/shared/constants';

export const resolveRoute = (
  order?: TGetOrderResponse,
  pageSettings?: TPageSettingsResponse,
): string => {
  const uploadedOrder = localStorage.getItem(UPLOADED_ORDER_LOCAL_STORAGE_KEY);
  const isCheckedUser = localStorage.getItem(CHECKED_USER_LOCAL_STORAGE_KEY) === order?.id;
  const isConfirmAmount = !!sessionStorage.getItem(MSP_CONFIRM_AMOUNT_SESSION_KEY);

  if (!order || !pageSettings) return '';

  if (successStatuses.includes(order.status)) return 'success';

  if (failStatuses.includes(order.status)) return 'dispute';

  if (order.status === ORDER_STATUS.REQUISITES_NOT_FOUND)
    return `/${order.id}/${NOT_FOUND_PAYMENT}`;

  if (order.status === IN_DISPUTE) return 'dispute/success';

  if (uploadedOrder === order.id) return 'search';

  if (pageSettings.cloudflare && !isCheckedUser) return 'check-user';

  if (order.status === 'INIT' && !isConfirmAmount) return `${MSP_PAGE}/${order.id}`;

  return '';
};
